import { type AudienceKind } from "features/mediaDataRoom/models";

export type LookalikeAudienceSeedOptionGroup =
  | "Seed"
  | "Remarketing"
  | "Lookalike"
  | "Rule-based";

export const seedOptionGroupPriority: Record<
  LookalikeAudienceSeedOptionGroup,
  number
> = {
  Lookalike: 2,
  Remarketing: 1,
  "Rule-based": 3,
  Seed: 0,
};

export interface LookalikeAudienceSeedOption {
  id: string;
  name: string;
  group: LookalikeAudienceSeedOptionGroup;
  isEmpty?: boolean;
}

export const mapAudienceKindToSeedOptionGroup: Record<
  AudienceKind,
  LookalikeAudienceSeedOptionGroup
> = {
  advertiser: "Remarketing",
  lookalike: "Lookalike",
  rulebased: "Rule-based",
};
